import * as fromRoot from '../../state/app.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AgentActions, AgentActitonTypes } from './agent.actions';
import { Agent } from '../../_models/agent';

import { DbTransform } from '../../_helpers/db.transform';

export interface State extends fromRoot.State {
	agents: AgentState;
}

export interface AgentState {
  currentAgent: Agent;
	agentList: Agent[];

	filterFields: any;

	error: string;
}

const dbt: DbTransform = new DbTransform(localStorage.getItem('enviroment'));

const initialItem: Agent = {
  id: null,
  user_id: null,
  name: '',
	username: '',
	role: '',
  lang: '',
	company: '',
	company_email: '',
  company_phone: '',
  dashboards: '',
  delivery: '',
  stock: '',
	email: '',
	phone: '',
  password: '',
  enviroment: '',
	permissions: '',
	group_id: 1
};

const initialState: AgentState = {
  currentAgent: initialItem,
	agentList: [],
	filterFields: [],
	error: ''
};

const getAgentFeatureState = createFeatureSelector<AgentState>('agents');

export const getCurrentAgent = createSelector(
    getAgentFeatureState,
    state => state.currentAgent
);

export const getAgentList = createSelector(
	getAgentFeatureState,
	state => state.agentList
);

export const getFilterFields = createSelector(
	getAgentFeatureState,
	state => state.filterFields
);

export const getError = createSelector(
	getAgentFeatureState,
	state => state.error
);

// Primer parámetro es el "estado ngrx" almacenado en ese momento.
// Segundo parámetro es la acción que se va a procesar.
export function reducer(state = initialState, action: AgentActions): AgentState {

	// console.log('--> Agent Reduce --> Estado actual: ' + JSON.stringify(state));
	// console.log('--> Action Agent type: ');
	// console.log(action.type);

	switch (action.type) {

		case AgentActitonTypes.SetCurrentAgent:

			console.log('--> Entando en acción SetCurrentAgent.');

			if (action.payload !== null) {

				return {
					...state,
					currentAgent: action.payload
				};
			} else {
				return {
					...state,
					currentAgent: initialItem
				};
			}

		case AgentActitonTypes.SetFilterFields:

			console.log('--> Entando en acción SetFilterFields.');

			return {
                ...state,
                filterFields: action.payload
			};

		case AgentActitonTypes.ClearAgent:

			console.log('--> Entando en acción ClearAgent.');

			return {
					...state,
					currentAgent: null
				};

		case AgentActitonTypes.InicializeAgent:

			console.log('--> Entando en acción InicializeAgent.');

			state = initialState;

			return state;


		case AgentActitonTypes.LoadAgentsSuccess:

			console.log('--> Entando en acción LoadAgentsSuccess. => Payload = ');
			console.log(action.payload);

			return {
					...state,
					agentList: action.payload,
					error: ''
				};

		case AgentActitonTypes.LoadAgentsFail:

			console.log('--> Entando en acción LoadAgentsFail. => Payload = ');
			console.log(action.payload);

			return {
					...state,
					agentList: [],
					error: action.payload
				};

		// case AgentActitonTypes.UpdateAgent:

		// 	console.log('--> Entando en acción UpdateAgent.');

		// 	// state = initialState;

		// 	return state;

		case AgentActitonTypes.UpdateAgentSuccess:

			console.log('--> Entando en acción UpdateAgentSuccess.');

			// Se actualiza en los proyectos actuales el proyecto que se ha modificado y el resto se deja como estaba.

			let auxAgentList = [];

			if (action.payload !== undefined) {
				console.log(' -> El agente a modificar es:');
				console.log(action.payload);

				if (action.payload != null) {
					auxAgentList = state.agentList.map(
					item => action.payload[dbt.t('user_id')] === item[dbt.t('user_id')] ? action.payload : item);

					return {
						...state,
						agentList: auxAgentList,
						currentAgent: action.payload,
						error: ''
					};
				}

				return state;

			} else {
				console.log(' -> El agente a modificar está vacío.');

				return {
					...state,
					error: 'No se ha podido modificar el agente.'
				};
			}

		case AgentActitonTypes.UpdateAgentFail:

			console.log('--> Entrando en acción UpdateAgentFail.');

			return {
					...state,
					error: action.payload
				};

		case AgentActitonTypes.CreateAgentSuccess:

			console.log('--> Entrando en acción CreateAgentSuccess.');

			if (action.payload !== undefined) {
				console.log(' -> El agente creado es:');
				console.log(action.payload);

				if (action.payload !== null) {

					console.log(' -> El listado de agentes es:');
					console.log(state.agentList);

					state.agentList.push(action.payload);

					console.log(' -> El listado de agentes tras añadir el nuevo es:');
					console.log(state.agentList);

					return {
						...state,
						agentList: state.agentList,
						error: ''
					};
				}

				return state;

			} else {
				console.log(' -> El elemento a crear está vacío.');

				return {
					...state,
					currentAgent: null,
					error: 'No se ha podido crear el agente.'
				};
			}

		case AgentActitonTypes.CreateAgentFail:

			console.log('--> Entrando en acción CreateAgentFail.');

			return {
					...state,
					currentAgent: null,
					error: action.payload
				};

		case AgentActitonTypes.DeleteAgentSuccess:

			console.log('--> Entrando en acción DeleteAgentSuccess.');

			if (action.payload !== undefined) {
				console.log(' -> Agente borrado con éxito es:');
				console.log(action.payload);

				if (action.payload !== null) {

					const filterList = state.agentList.filter((item) => item[dbt.t('user_id')].toString() !== action.payload.toString());

					console.log(' -> Lista filtrada de agentes:');
					console.log(filterList);

					return {
						...state,
						agentList: filterList,
						currentAgent: null,
						error: ''
					};
				}

				return state;

			} else {
				console.log(' -> El agente a crear está vacío.');

				return {
					...state,
					currentAgent: null,
					error: 'No se ha podido crear el agente.'
				};
			}

		case AgentActitonTypes.DeleteAgentFail:

			console.log('--> Entrando en acción DeleteAgentSuccess.');

			return {
					...state,
					currentAgent: null,
					error: action.payload
				};

		default:
			return state;
	}
}
